import { Empty, Flex, Tag } from 'antd'
import { useIntl } from 'react-intl'
import { DownOutlined } from '@ant-design/icons'
import Button from '../../../../common/Button'
import NoRecordsFound from '../../../../common/NoRecordsFound'
import RecordsCount from '../../../../common/RecordsCount'

const SalesCodeListPanel = ({
  salesCodeList,
  expandedRowKeys,
  expandedDetails,
  onToggleExpand,
  onPreview,
  onDelete,
}) => {
  const intl = useIntl()
  return (
    <div className="sales-code-list-panel">
      <div className="panel-header">{intl.formatMessage({ id: 'generic.name' })}</div>
      <div className="panel-body">
        {salesCodeList?.map((list) => {
          const isExpanded = expandedRowKeys.includes(list.id)
          return (
            <div key={list.id} className="panel-row-group" data-testid="fd-sales-list-row" data-name={list.name}>
              <Flex
                justify="space-between"
                align="center"
                className="panel-row"
              >
                <span>{list.name}</span>
                <Flex gap={16} align="center">
                  <Button
                    type="link"
                    className={`${isExpanded ? 'link-button neutral' : 'link-button'}`}
                    style={{ padding: 0, gap: 6 }}
                    onClick={() => onToggleExpand(list.id)}
                    testId="fd-list-details"
                  >
                    {intl.formatMessage({ id: 'generic.details' })}
                    <DownOutlined
                      style={{ fontSize: 10 }}
                      rotate={isExpanded ? 180 : 0}
                    />
                  </Button>
                  <Button
                    type="link"
                    className="link-button"
                    onClick={() => onPreview(list)}
                    testId="fd-list-preview"
                  >
                    {intl.formatMessage({ id: 'functionalDiagram.preview' })}
                  </Button>
                  <Button
                    type="link"
                    className="link-button danger"
                    onClick={() => onDelete(list)}
                    testId="fd-list-delete"
                  >
                    {intl.formatMessage({ id: 'forms.delete' })}
                  </Button>
                </Flex>
              </Flex>
              {isExpanded && (
                <Flex wrap="wrap" gap={8} className="panel-expanded">
                  {expandedDetails[list.id]?.map((code) => (
                    <Tag key={code.id || code.value}>
                      {code.label || code.name}
                    </Tag>
                  ))}
                  {(!expandedDetails[list.id] ||
                    expandedDetails[list.id].length === 0) && (
                    <Empty
                      description={<RecordsCount count={0} />}
                      style={{ margin: '0 auto' }}
                    />
                  )}
                </Flex>
              )}
            </div>
          )
        })}
      </div>
      {(!salesCodeList || salesCodeList.length === 0) && (
        <Empty
          description={<RecordsCount count={0} />}
          style={{
            margin: '0 auto',
            height: 'calc(65vh - 92px)',
            // paddingTop: '30%',
          }}
        />
      )}
    </div>
  )
}

export default SalesCodeListPanel
